/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Go_To_Event_EndInputs */



/**
* | output |
* | --- |
* | "Go To End Of Event" |
*
* @param {Shortcut_Keys_Name_Go_To_Event_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_go_to_event_end = /** @type {((inputs?: Shortcut_Keys_Name_Go_To_Event_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Go_To_Event_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aller a la fin de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gehe zum Ende der Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vai alla fine dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к концу мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ir al final del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("前往活动结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの最後へ移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट के अंत में जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o final do evento")
	return /** @type {LocalizedString} */ ("Go To End Of Event")
});